import React, {useContext, useEffect, useState} from "react";
import LOGO from "../img/LOGO.png";
import lg from "../img/lg.png"

import effects from 'uploadcare-widget-tab-effects/react-en'

import {Helmet} from "react-helmet";

import { createClient } from '@supabase/supabase-js'

import { Widget } from "@uploadcare/react-widget";

const supabase = createClient('https://sxipkzxjsnnaybxthrxf.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN4aXBrenhqc25uYXlieHRocnhmIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzY3NDEwMzgsImV4cCI6MTk5MjMxNzAzOH0.ToB8TL555TnCAjl_jmNdhY86bmTvttL5K1aRAlZUOI8')
const AddPhotoYearPage = () => {
    const alterLocale = () => ({
        buttons: {
            choose: {
                files: {
                    one: "Прикрепить фото"
                }
            }
        }
    });

    const [ photo, setPhoto ] = useState()
    const [ city, setCity ] = useState('')
    const [ address, setAddress ] = useState('')
    const [ url, setUrl ] = useState('')

    //
    async function fetchData () {
        const { data, error } = await supabase
            .from('cities')
            .select('value, label, geo_lat, geo_lon, count')
            .gt('count', 0)
        return data
    }
    //
    // useEffect(() => {
    //     console.log(photo)
    // }, [photo])

    const uploadPhoto = async () => {
        console.log(photo)
        console.log(city)
        console.log(address)
        console.log(url)
        const { error } = await supabase
            .from('images')
            .insert(
                {
                    uuid: photo.uuid,
                    cdn_url: photo.cdnUrl,
                    width: photo.originalImageInfo.width ,
                    height: photo.originalImageInfo.height ,
                    crop: !!photo.crop ,
                    crop_width: photo.crop ? photo.crop.width : null ,
                    crop_height: photo.crop ? photo.crop.height : null,
                    city: city,
                    address: address,
                    source: url
                }
            )
        if (error) {
            alert(error.message)
        } else {
            alert('ok')
            setPhoto(null)
            setCity('')
            setAddress('')
            setUrl('')
        }
    }






    return (
        <div className='bg-gray-50'>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Хроника протестов в России - Присоединиться</title>
                <meta name="description" content="Список антивоенных движений в России"/>

                {/*Facebook Meta Tags*/}
                <meta property="og:url" content="https://remap-ru.com/join"/>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content="Хроника протестов в России - Присоединиться"/>
                <meta property="og:description" content="Список антивоенных движений в России"/>
                <meta property="og:image" content={LOGO}/>

            </Helmet>

            <main className=''>
                <div className='py-20'>
                    <div className='flex max-w-7xl mx-auto items-center px-3'>
                        <div className='w-auto'>
                            <img src={lg} width={80} alt=""/>
                        </div>
                        <div className='pl-6'>
                            <h2 className='text-2xl font-bold text-neutral-900'>24.02.2023</h2>
                            <h1 className='text-4xl font-bold text-neutral-800 pt-1'>РОССИЯ СКОРБИТ</h1>
                            <h1 className='text-2xl font-bold text-neutral-900 pt-1'>День памяти и скорби*</h1>
                        </div>
                    </div>
                    {/*<img src={low} alt=""/>*/}
                </div>
                <div className='max-w-7xl mx-auto px-4'>
                    <div className='max-w-md flex items-center mx-auto flex-col py-4'>
                        {/*<label htmlFor='file'>Your file:</label>{' '}*/}
                        <Widget publicKey='4ce3b8f785eacb4c6b0d' id='file'
                                crop="free, 16:9, 4:3, 5:4, 1:1"
                                locale={'ru'}
                                tabs="file url" localeTranslations={alterLocale()}
                                customTabs={{ preview: effects }}
                                onChange={info => setPhoto(info)}
                        />
                        
                        {
                            photo ?
                                <div className=''>
                                    <img src={photo.cdnUrl} className='rounded pt-4' alt=""/>
                                    <div className='w-full pt-4'>
                                        <div className='pt-1'>Город:</div>
                                        <input value={city} onChange={event => {setCity(event.target.value)}}
                                               type='text' className='border px-4 py-2 w-full rounded'/>
                                        <div className='pt-1'>Адрес:</div>
                                        <input value={address} onChange={event => {setAddress(event.target.value)}}
                                               type='text' className='border px-4 py-2 w-full rounded'/>
                                        <div className='pt-1'>Источник:</div>
                                        <input value={url} onChange={event => {setUrl(event.target.value)}}
                                               type='url' className='border px-4 py-2 w-full rounded'/>
                                    </div>
                                    <div className='mt-4 border rounded bg-blue-500 text-center py-2 text-white cursor-pointer'
                                         onClick={() => uploadPhoto()}
                                    >Сохранить в базу</div>
                                </div>
                                :
                                <div className='bg-gray-200 aspect-square w-60 mt-8'>
                                </div>
                        }
                        <div>
                            
                        </div>
                        {/*<div>Город:</div>*/}
                        {/*<Select onChange={(choice) => onSChange(choice)} onInputChange={(newValue=>{onIChange(newValue)})} options={options} />*/}

                        {/*<div className='pt-4'>Количество:</div>*/}
                        {/*<input value={count} onChange={(e)=> setCount(e.target.value)} type="number" placeholder={value?.count} className='w-full border border-neutral-300 rounded p-2 outline-blue-500'/>*/}

                        {/*<div className='flex'>*/}
                        {/*    <div onClick={() => updateItem()} className='mt-6 bg-blue-400 px-4 py-2 rounded cursor-pointer hover:bg-blue-400'>*/}
                        {/*        Сохранить*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                    </div>

                </div>

                {/*<div className='max-w-7xl mx-auto px-4 py-12'>*/}
                {/*    <div className='border '>*/}

                {/*    </div>*/}
                {/*    <div className="flex flex-col">*/}
                {/*        <div className="-m-1.5 overflow-x-auto">*/}
                {/*            <div className="p-1.5 min-w-full inline-block align-middle">*/}
                {/*                <div className="overflow-hidden">*/}
                {/*                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">*/}
                {/*                        <thead>*/}
                {/*                        <tr>*/}
                {/*                            <th scope="col"*/}
                {/*                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Город*/}
                {/*                            </th>*/}
                {/*                            <th scope="col"*/}
                {/*                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">К-во мемориалов*/}
                {/*                            </th>*/}
                {/*                            <th scope="col"*/}
                {/*                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Широта*/}
                {/*                            </th>*/}
                {/*                            <th scope="col"*/}
                {/*                                className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Долгота*/}
                {/*                            </th>*/}
                {/*                        </tr>*/}
                {/*                        </thead>*/}
                {/*                        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">*/}

                {/*                            <tr>*/}
                {/*                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200">*/}
                {/*                                    123*/}
                {/*                                </td>*/}
                {/*                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200 font-medium">*/}
                {/*                                    123*/}
                {/*                                </td>*/}
                {/*                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200">*/}
                {/*                                   123*/}
                {/*                                </td>*/}
                {/*                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm ">*/}
                {/*                                   123*/}
                {/*                                </td>*/}
                {/*                            </tr>*/}




                {/*                        </tbody>*/}
                {/*                    </table>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}


            </main>
        </div>
    )
}

export default AddPhotoYearPage